import { to } from "await-to-js";
import http from "../http";
import urls from "../urls";

export default new (class {
  getAllUsers() {
    var url = new URL(window.location.href);
    var page = url.searchParams.get("page");
    if (page === null) {
      return to(http.get(`${urls.users.get}`));
    } else {
      return to(http.get(`${urls.users.get + "?page=" + page}`));
    }
  }

  getUserById(id) {
    return to(http.get(`${urls.users.get}/${id}`));
  }

  updateUserById(data) {
    let formData = new FormData();
    formData.append("name", data.name);
    formData.append("email", data.email);
    formData.append("password", data.password);
    return to(http.post(`${urls.users.post}/${data.id}`, formData));
  }

  deleteUserById(id) {
    return to(http.delete(`${urls.users.post}/${id}`));
  }

  registerUser(user) {
    let formData = new FormData();
    formData.append("name", user.name);
    formData.append("email", user.email);
    formData.append("password", user.password);
    formData.append("confirm_password", user.password);
    return to(http.post(`${urls.users.post}`, formData));
  }

  resetPassword(pass) {
    let formData = new FormData();
    formData.append("email", pass);
    return to(http.post(`${urls.users.reset}`, formData));
  }
})();
